// @ts-nocheck -- TypeScript migration in progress: bulk-renamed from .js and not
// yet typed. Remove this directive and add real types when converting this
// module. Backlog: grep -rl "@ts-nocheck" src. See docs/typescript-migration.md.
// Engine-monitor make/model <select> pair helpers: populate both
// selects with the supported monitor catalog (optionally including the
// "Other" sentinel for the contact form) and read back the selected
// monitor as a structured value.
//
// Exposed as a factory because the "Other" sentinel and escapeHtml
// helper live in app.js.

import {
  supportedMonitorMakes,
  supportedMonitorModelsForMake,
} from "./supported-monitors.js";
import { selectedMonitorFromSelectValues } from "./aircraft-upload-model.js";

export function createMonitorSelects({ monitorOtherChoice, escapeHtml }) {
  function populateMonitorSelects(makeSelect, modelSelect, selectedMake = "", selectedModel = "", options = {}) {
    if (!makeSelect || !modelSelect) return;
    const includeOther = options.includeOther === true;
    const makes = supportedMonitorMakes();
    const availableMakes = includeOther ? [...makes, monitorOtherChoice] : makes;
    const make = availableMakes.includes(selectedMake) ? selectedMake : (selectedMake ? "" : makeSelect.value);
    makeSelect.innerHTML = [
      '<option value="">Select make...</option>',
      ...makes.map((entry) => `<option value="${escapeHtml(entry)}">${escapeHtml(entry)}</option>`),
      ...(includeOther ? [`<option value="${monitorOtherChoice}">${monitorOtherChoice}</option>`] : []),
    ].join("");
    makeSelect.value = availableMakes.includes(make) ? make : "";
    const models = makeSelect.value === monitorOtherChoice ? [] : supportedMonitorModelsForMake(makeSelect.value);
    modelSelect.innerHTML = [
      '<option value="">Select model...</option>',
      ...models.map((entry) => `<option value="${escapeHtml(entry)}">${escapeHtml(entry)}</option>`),
    ].join("");
    modelSelect.disabled = !makeSelect.value || makeSelect.value === monitorOtherChoice || makeSelect.disabled;
    modelSelect.value = models.includes(selectedModel) ? selectedModel : "";
  }

  function selectedMonitorFromSelects(makeSelect, modelSelect) {
    return selectedMonitorFromSelectValues(makeSelect?.value, modelSelect?.value);
  }

  return {
    populateMonitorSelects,
    selectedMonitorFromSelects,
  };
}
